import React, { Component } from 'react'
import MultiSelect from '../MultiSelect/MultiSelect'
import './styles.sass'
import Sticky from '../Sticky/Sticky';
export default class SearchFilters extends Component {
    constructor(props) {
        super(props)

        this.state = {
            openFilterMobile: false,
            openFilter: false,
            indexFilter: "",
            sticked: false,
            multiselects: [] 
        }
    }

    handleOpenSelect = (index, open) => {
        const { indexFilter } = this.state
        if (open && indexFilter.toString.length > 0 ){
            const { callbackApplyFilter } = this.props
            if (callbackApplyFilter) callbackApplyFilter('changeSelect');
        }else{
            this.setState({
                indexFilter: open ? index : ""
            })
        }
    }

    handleOpenFilter = (open) => {
        this.setState({
            openFilterMobile: open
        })
    }

    handleReset = () => {
        const { callbackReset } = this.props
        if (callbackReset) callbackReset()
    }

    handleSticky = sticky => {
        this.setState({
            sticked: sticky
        })
    }

    handleApplyFilter = (index, open) => {
        const { callbackApplyFilter } = this.props
        if (callbackApplyFilter) callbackApplyFilter('changeSelect');
        this.handleOpenSelect(index, open);
    }

    getCountItems = (index) => {
        const { itemsList } = this.props
        let count = 0
        itemsList.selects[index].options.map((option) => {
            count += option.items.length
        })
        return count
    }

    getQuery = () => {
        let adulti = this.props.adulti
        let query = ""
        const multiselects = this.state.multiselects
        query += this.getCountItems(0) > multiselects[0].itemSelected.flat().length ? "&seats="+multiselects[0].itemSelected.flat().join(",") : ""
        
        //const seats = multiselects[0].itemSelected.flat().join(",");
        if (adulti){
            query += this.getCountItems(1) > multiselects[1].itemSelected.flat().length ? "&activities="+multiselects[1].itemSelected.flat().join(",") : ""
            query += this.getCountItems(2) > multiselects[2].itemSelected.flat().length ? "&courses="+multiselects[2].itemSelected.flat().join(",") : ""
            query += this.getCountItems(3) > multiselects[3].itemSelected.flat().length ? "&trainers="+multiselects[3].itemSelected.flat().join(",") : ""
        }else{
            query += this.getCountItems(2) > multiselects[2].itemSelected.flat().length ? "&activities="+multiselects[2].itemSelected.flat().join(",") : ""
            query += this.getCountItems(3) > multiselects[3].itemSelected.flat().length ? "&courses="+multiselects[3].itemSelected.flat().join(",") : ""
            query += "&year="+multiselects[1].itemSelected.flat().join(",")
        }
        // const activities = adulti ? multiselects[1].itemSelected.flat().join(",") : multiselects[2].itemSelected.flat().join(",")
        // const courses = adulti ? multiselects[2].itemSelected.flat().join(",") : multiselects[3].itemSelected.flat().join(",")
        // const trainers = adulti ? multiselects[3].itemSelected.flat().join(",") : null
        // const years = adulti ? null :  multiselects[1].itemSelected.flat().join(",")

        // query = "&seats="+seats+"&activities="+activities+"&courses="+courses+"&trainers="+trainers+"&year="+years

        return query;
    }

    componentDidMount = () => {
        const { itemsList} = this.props;
        for (let index = 0; index < itemsList.selects.length; index++) {
           this.initList(index)
        }
    }


    // getDerivedStateFromProps = (nextProps, prevState) => {
    //     console.log('getDerivedStateFromProps    diff nextProps.itemsList!==prevState.itemsList', nextProps.itemsList!==prevState.itemsList);
        
    //     if(nextProps.itemsList!==prevState.itemsList){
    //         const { itemsList} = this.nextProps;
    //         for (let index = 0; index < itemsList.selects.length; index++) {
    //            this.initList(index)
    //         }
    //    }
    //    else return null;
    // }

    // shouldComponentUpdate = () => (nextProps, nextState) => {
    //     const { itemsList} = this.nextProps;
    //     for (let index = 0; index < itemsList.selects.length; index++) {
    //         this.initList(index)
    //     }
    //     return true;
    // }

    initList = (index) => {
        let arrayGroup = []
        let arrayItems = []
        let masterChecked = false;
        let arrayTag = []
        let arrayGroupTag = []
        let arrayMasterChecked = []


        const itemsList = this.props.itemsList.selects[index];
        
        itemsList.options.map((group, index) => {
          arrayItems = []
          arrayTag = []
          masterChecked = group.isChecked
          group.items.map((item, index) => {
            if(item.isChecked || masterChecked) {
              arrayItems.push(item.id)
              arrayTag.push(group.items.find(x => x.id === item.id) )
            }
          })
          arrayMasterChecked.push(masterChecked ? true : null)
          arrayGroup.push(arrayItems)
          arrayGroupTag.push(arrayTag)
        })
        // console.log('arrayGroup',arrayGroup);
        // console.log('arrayGroupTag',arrayGroupTag);
        // console.log('----------------------------');
        
        const multiselects = this.state.multiselects;
        multiselects.push({
            itemSelected: arrayGroup,
            tagSelected: arrayGroupTag,
            masterSelected: arrayMasterChecked
        })

        this.setState({
            multiselects
        }, () => {
            this.props.setQueryParam(this.getQuery("changeSelect"));
        });
        /* this.setState({
          itemSelected: arrayGroup,
          tagSelected: arrayGroupTag,
          masterSelected: arrayMasterChecked
        })*/
        
      }

      handleItemSelection = (items, index, multiSelectIndex) => {
        
        const multiselects = this.state.multiselects;
        const singleMultiselects = multiselects[multiSelectIndex];
        
        let itemSelected = singleMultiselects.itemSelected
        let masterSelected = singleMultiselects.masterSelected
        itemSelected[index] = items
        masterSelected[index] = this.props.itemsList.selects[multiSelectIndex].options[index].items.length == items.length ? true : null

        singleMultiselects.itemSelected = itemSelected;
        singleMultiselects.masterSelected = masterSelected;

        multiselects[multiSelectIndex] = singleMultiselects;

        this.setState({
            multiselects
        }, () => {
            this.props.setQueryParam(this.getQuery("changeSelect"));
        });

      }

        
  handleMasterSelection = (items, index, masterChecked, multiSelectIndex) => {
    const multiselects = this.state.multiselects;
    const singleMultiselects = multiselects[multiSelectIndex];
    
    let itemSelected = singleMultiselects.itemSelected
    let masterSelected = singleMultiselects.masterSelected
    itemSelected[index] = items
    masterSelected[index] = masterChecked
    multiselects[multiSelectIndex] = singleMultiselects;
    
    this.setState({
        multiselects
    }, () => {
        this.props.setQueryParam(this.getQuery("changeSelect"));
    });

  }

  removeTagSelected = (index, val, multiSelectIndex) => {

    const multiselects = this.state.multiselects;
    const singleMultiselects = multiselects[multiSelectIndex];
    
    let itemSelected = singleMultiselects.itemSelected

    this.handleItemSelection(itemSelected[index].filter(e => e !== val),index, multiSelectIndex)

    itemSelected[index] = itemSelected[index].filter(e => e !== val)
    multiselects[multiSelectIndex] = singleMultiselects;

    this.setState({
        multiselects
    }, () => {
        this.props.setQueryParam(this.getQuery("changeSelect"));
    });
  }


    render() {
        const { itemsList, labels } = this.props
        const { indexFilter, openFilterMobile, sticked, multiselects } = this.state

        return (
            
            <div className={`wrapper-sticky ${sticked ? 'sticked' : ''}`}>
                <Sticky callback={this.handleSticky}>
                    <section className="search-area">


                        <div className={`accordion-filter ${openFilterMobile ? "open" : ""}`} onClick={() => this.handleOpenFilter(!openFilterMobile)}>{labels.filtersBox_accordion_title}</div>

                        {/* <div className={`accordion-filter ${openFilterMobile ? "open" : ""}`} onClick={() => this.handleOpenFilter(!openFilterMobile)}>{labels.filtersBox_accordion_title}</div> */}
                        <div className={`wrapper-filter ${openFilterMobile ? "open" : ""}`}>
                            <div className="filters-reset">
                                <p>{labels.filtersBox_intro}</p>
                                <p className="reset" onClick={() => this.handleReset()}>{labels.filtersBox_reset}</p>
                                <a className="btnNoDesk btn-orange" onClick={() => this.handleOpenFilter(!openFilterMobile)} href="#calendar-content">{labels.filtersBox_anchor}</a>
                            </div>
                            <div className="filters-select">
                                {
                                    itemsList.selects.map((select, selectIndex) => {
                                        //console.log("indexFilter==index", indexFilter===index, indexFilter, " ", index);
                                       
                                        return (
                                            <div key={selectIndex} className="filter">
                                                <MultiSelect removeTagSelected={this.removeTagSelected} handleMasterSelection={(items, index, masterChecked, multiSelectIndex) => this.handleMasterSelection(items, index, masterChecked, multiSelectIndex)} handleMasterSelection={(items, index, masterChecked, multiSelectIndex) => this.handleMasterSelection(items, index, masterChecked, multiSelectIndex)} handleItemSelection={(items, index, multiSelectIndex) => this.handleItemSelection(items, index, multiSelectIndex)} labels={labels} itemSelected={multiselects[selectIndex] ? multiselects[selectIndex].itemSelected : []} masterSelected={multiselects[selectIndex] ? multiselects[selectIndex].masterSelected : []} callbackApplyFilter={this.handleApplyFilter} open={indexFilter === selectIndex} index={selectIndex} itemsList={select} type={select.multiSelect ? "checkbox" : "radio"} callbackOpen={(indexMulti, open) => this.handleOpenSelect(indexMulti, open)} />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </section>
                </Sticky>
            </div>
        )
    }
}
